import { useState } from 'react';

export default props => {
	// console.log("props: ", props);
	const jsx = (<div className="this-content hiddenable" style={{display: props.display}}>
		<style jsx>{`
.this-content{
	position:absolute;
}

.arrow_box {
	position: relative;
	top: 5px;
	right: 40px;

	box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.12);
	border: solid 1px #dee2e6;
	background-color: #ffffff;

	font-family: NotoSansCJKkr;
	font-size: 14px;
	color: #343a40;
	border-radius: 5px;

}

.arrow_box:after, .arrow_box:before {
	bottom: 100%;
	left: 50%;
	border: solid transparent;
	content: " ";
	height: 0;
	width: 0;
	position: absolute;
	pointer-events: none;
}

.arrow_box:before {
	border-color: rgba(222, 226, 230, 0);
	border-bottom-color: #dee2e6;
	border-width: 7px;
	margin-left: -7px;
}


.arrow_box:after {
	border-color: rgba(255, 255, 255, 0);
	border-bottom-color: #ffffff;
	border-width: 6px;
	margin-left: -6px;
}

span{
	float: left;
}


.item{
	padding: 8px 30px;
	text-align:center;
	line-height: 1.71;
}

`}</style>

		<div className="arrow_box">
			<div className="item mouse-aa" onClick={() => { props.hide(); props.setLang('korean'); location.reload();}} >Korean</div>
			<div className="horizon-bar" />
			<div className="item mouse-aa" onClick={() => { props.hide(); props.setLang('vietnam'); location.reload();}} >Vietnam</div>
		</div>


	</div>);
	return(jsx);
}
